import { Box, Table, TableBody, TableHead, TableRow } from "@mui/material";
import React from "react";
import { textJa } from "../../locales/textJa";
import { registerPeopleType } from "../../types/type";
import { StyledCell, StyledHeader } from "../common/styles/tablecell";
import { Row } from "./Row";

type Props = {
  items: registerPeopleType[];
  getSpeaker: () => Promise<void>;
};

export const RegisterPersonPerformance: React.FC<Props> = ({
  items,
  getSpeaker,
}) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Table
        aria-label="sticky table"
        sx={{
          whiteSpace: "nowrap",
        }}
      >
        <TableHead sx={{ padding: "16px 8px" }}>
          <TableRow>
            <StyledCell>
              <StyledHeader>{textJa.registerPerson.id}</StyledHeader>
            </StyledCell>
            <StyledCell>
              <StyledHeader>{textJa.common.speakername}</StyledHeader>
            </StyledCell>
            <StyledCell>
              <StyledHeader>{textJa.common.sitename}</StyledHeader>
            </StyledCell>
            <StyledCell>
              <StyledHeader>{textJa.registerPerson.author}</StyledHeader>
            </StyledCell>
            <StyledCell>
              <StyledHeader>{textJa.registerPerson.createAt}</StyledHeader>
            </StyledCell>
            <StyledCell></StyledCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(
            (item, index) =>
              item && (
                <TableRow
                  key={item.id ? (item.id as string) : index}
                  sx={{ padding: "8px" }}
                >
                  <Row item={item} getSpeaker={getSpeaker} />
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </Box>
  );
};
